import React from 'react';
import { Button, Icon, Container } from 'semantic-ui-react';
var partsStyle = {
    display: 'inline-block',
    margin: '0.5em',
};
export var Footer = function () {
    return (React.createElement(Container, { style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
        } },
        React.createElement("span", { style: partsStyle }, "\u00A9 " + new Date().getFullYear() + " Born Brave LTD, \u0412\u0441\u0438\u0447\u043A\u0438 \u043F\u0440\u0430\u0432\u0430 \u0437\u0430\u043F\u0430\u0437\u0435\u043D\u0438.  ",
            React.createElement("span", null,
                React.createElement("a", { href: "https://www.iubenda.com/privacy-policy/89587853" }, "\u041F\u043E\u0432\u0435\u0440\u0438\u0442\u0435\u043B\u043D\u043E\u0441\u0442"),
                React.createElement("span", null, ", "),
                React.createElement("a", { href: "https://www.iubenda.com/privacy-policy/89587853/cookie-policy" }, "\u0431\u0438\u0441\u043A\u0432\u0438\u0442\u043A\u0438"),
                React.createElement("span", null, " \u0438 "),
                React.createElement("a", { href: "/terms" }, "\u043E\u0431\u0449\u0438\u0442\u0435 \u0443\u0441\u043B\u043E\u0432\u0438\u044F"))),
        React.createElement("span", { style: partsStyle },
            React.createElement("a", { href: 'mailto:info@bookinggood.net' },
                React.createElement(Button, { basic: true },
                    React.createElement(Icon, { name: "mail outline" }),
                    "\u0421\u0432\u044A\u0440\u0436\u0438 \u0441\u0435 \u0441 \u043D\u0430\u0441")),
            "\u00A0",
            React.createElement(Button, { basic: true, icon: "facebook", as: "a", href: "https://www.facebook.com/bookinggood.net" }))));
};
//# sourceMappingURL=Footer.js.map